import React from 'react';
import Sidebar from '../sidebar/Sidebar';




const Help = () => {
    return (
        <div className="dashboard">
            <Sidebar />
                <div className="content-card">
                    {/* Content Goes Here */}
                  <h1>Coming Soon</h1>
                </div>
            </div>
       
    );
};

export default Help;